export default "__VITE_ASSET__BWTqOUNV__"